import log from 'loglevel';
import React, { createContext, useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { usePlayerContext } from '../Context';
import { QualityLevelEvents } from '../../sdk/PlayerEvents';
import {
  Events,
  State,
  QualityLevel,
  QualityLevelKind,
} from '../../types/player';
import ControlMenu from '../ui/ControlMenu';
import SelectControl, { Item } from '../ui/SelectControl';
import { off } from 'process';

const Selector = (props: { kind: QualityLevelKind }) => {
  const { sdk } = usePlayerContext();
  const { t } = useTranslation();
  const { kind } = props;
  let listeners: any = [];

  const [isAutoQualityLevel, setAutoQualityLevel] = useState(
    sdk.isAutoQualityLevel(kind),
  );
  const [qualityLevels, setQualitylevels] = useState(
    sdk.getQualityLevels(kind),
  );
  let index = -1;
  const slug = 'quality-' + kind;
  if (sdk.hasQualityLevels(kind)) {
    index = sdk.getCurrentQualityLevel(kind)?.index || -1;
  }

  const [currentQualityLevelIndex, setCurrentQualityLevelIndex] = useState(
    isAutoQualityLevel ? -1 : index,
  );
  const [
    currentQualityLevelIndexWhenAuto,
    setCurrentQualityLevelIndexWhenAuto,
  ] = useState(index);

  useEffect(() => {
    listeners.push(
      sdk.on(Events.QUALITYLEVEL_CHHANGED, (event: QualityLevelEvents) => {
        console.log('QualityLevelsSelector: QualityLevel changed', event);
        if (event.kind !== kind) return;
        setQualitylevels(sdk.getQualityLevels(kind));
        setAutoQualityLevel(event.isAutoQualityLevel);
        setCurrentQualityLevelIndexWhenAuto(event.index);
        if (event.isAutoQualityLevel != true)
          setCurrentQualityLevelIndex(event.index);
        else setCurrentQualityLevelIndex(-1);
      }),
    );
    return () => {
      listeners.forEach((off: any) => off());
    };
  }, []);

  function setCurrentQualityLevel(index: string) {
    sdk.setCurrentQualityLevel(parseInt(index) as number, kind);
    sdk.toggleControlMenu('quality');
  }

  function autoBuildLabelAuto(qualityLevel: QualityLevel) {
    if (qualityLevel.width && qualityLevel.height)
      return `${qualityLevel.width}x${qualityLevel.height}`;
    else if (qualityLevel.bitrate) return `${qualityLevel.bitrate / 1000} kbps`;
    else return qualityLevel.index;
  }

  function autoBuildLabel(qualityLevel: QualityLevel) {
    if (qualityLevel.width && qualityLevel.height && qualityLevel.bitrate)
      return `${qualityLevel.width}x${qualityLevel.height} ${qualityLevel.bitrate / 1000} kbps`;
    else if (qualityLevel.bitrate) return `${qualityLevel.bitrate / 1000} kbps`;
    else if (qualityLevel.width && qualityLevel.height)
      return `${qualityLevel.width}x${qualityLevel.height}`;
    else if (qualityLevel.label) return qualityLevel.label;
    else return qualityLevel.index;
  }

  function getQualityLevelLabel(
    qualityLevel: QualityLevel,
    kind: QualityLevelKind,
  ) {
    let hook = sdk.options().getLocale()?.hooks?.qualityLevelLabel;
    if (hook) {
      const customLabel = hook(qualityLevel, kind);
      if (customLabel) return customLabel;
    }

    //console.log('qualityLevel', qualityLevel)
    if (qualityLevel.label == 'Auto') {
      if (qualityLevels[currentQualityLevelIndexWhenAuto] && isAutoQualityLevel)
        return `${t('Auto')} (${autoBuildLabelAuto(qualityLevels[currentQualityLevelIndexWhenAuto])})`;
      else return `${t('Auto')}`;
    }

    return `${autoBuildLabel(qualityLevel)}`;
  }

  if (!sdk.hasQualityLevels(kind)) {
    return null;
  }

  const items: Item[] = [];

  if (sdk.isAutoQualityLevelAvailable(kind)) {
    let fakeAutoQualityLevel: QualityLevel = {
      bitrate: 0,
      label: 'Auto',
    };
    items.push({
      val: -1,
      label: getQualityLevelLabel(fakeAutoQualityLevel, kind),
    });
  }

  qualityLevels.map((level, index) => {
    items.push({
      val: index,
      label: getQualityLevelLabel(level, kind),
    });
  });

  if (items.length < 2) return null;

  return (
    <SelectControl
      items={items}
      controlSlug={slug}
      currentValue={currentQualityLevelIndex}
      handleAction={setCurrentQualityLevel}
    />
  );
};

const QualityLevelsSelector = () => {
  const { sdk } = usePlayerContext();
  const { t } = useTranslation();

  const slug = 'quality';

  let videoCount = sdk.getQualityLevels(QualityLevelKind.VIDEO).length;
  let audioCount = sdk.getQualityLevels(QualityLevelKind.AUDIO).length;

  if (videoCount < 2 && audioCount < 2) return null;

  const selector = (
    <div
      className={`${sdk.getClassNamePrefix()}-player-control-menu-list ${sdk.getClassNamePrefix()}-player-control-menu-list-${slug}`}
    >
      {sdk.getQualityLevels(QualityLevelKind.VIDEO).length >= 2 && (
        <>
          {audioCount >= 2 && <h3>Vidéo</h3>}
          <Selector kind={QualityLevelKind.VIDEO} />
        </>
      )}
      {sdk.getQualityLevels(QualityLevelKind.AUDIO).length >= 2 && (
        <>
          {videoCount >= 2 && <h3>Audio</h3>}
          <Selector kind={QualityLevelKind.AUDIO} />
        </>
      )}
    </div>
  );

  return (
    <ControlMenu
      icon={'sliders'}
      controlClassName={'quality'}
      title={'Quality'}
      content={selector}
    />
  );
};

export { Selector };

export default QualityLevelsSelector;
